import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    announcementFlag: false,
    keyedMap: {},
    appId: "",
    projectType: '',
    customBackgroundStyles: null,
    lockedFeatureDialogVisible: false,
    lockedFeatureDialogType: null,
    meetingListPreference: '',
    isCountDownMusicMuted: false,
    musicPermissionDialogSeen: false,
  },
  mutations: {
    setAnnouncementFlag(state, flag) {
      Vue.set(state, 'announcementFlag', flag);
    },
    setKeyedMapItem(state, item) {
      Vue.set(state.keyedMap, item.id, item);
    },
    setAppId(state, app_id) {
      Vue.set(state, 'appId', app_id);
    },
    setCountDownMusicMuted(state, isMuted) {
      Vue.set(state, 'isCountDownMusicMuted', isMuted);
    },
    setMusicPermissionDialogSeen(state, seen) {
      Vue.set(state, 'musicPermissionDialogSeen', seen);
    },
    setProjectType(state, project_type) {
      Vue.set(state, 'projectType', project_type);
    },
    setCustomBackgroundStyles(state, styles) {
      state.customBackgroundStyles = styles;
    },
    showLockedFeatureDialog(state, type) {
      state.lockedFeatureDialogVisible = true;
      state.lockedFeatureDialogType = type;
    },
    hideLockedFeatureDialog(state) {
      state.lockedFeatureDialogVisible = false;
    },
    setMeetingListPreference(state, value) {
      Vue.set(state, 'meetingListPreference', value);
    }
  },
  getters: {
    getAnnouncementFlag: state => {
      return state.announcementFlag;
    },
    getKeyedMapItem: state => (id) => {
      let item = state.keyedMap[id]
      return item// == null ? null : item
    },
    getAppId: state => {
      return state.appId;
    },
    getCountDownMusicMuted: state => {
      return state.isCountDownMusicMuted;
    },
    getMusicPermissionDialogSeen: state => {
      return state.musicPermissionDialogSeen;
    },
    getProjectType: state => {
      return state.projectType;
    },
    getMeetingListPreference: state => {
      if (state.meetingListPreference) {
        return state.meetingListPreference;
      }
      return '';
    }
  },
  actions: {
    setAnnouncementFlag(context, {flag}) {
      context.commit('setAnnouncementFlag', flag);
    },
    setKeyedMapItem(context, {item}) {
      context.commit('setKeyedMapItem', item);
    },
    setAppId(context, {app_id}) {
      context.commit('setAppId', app_id);
    },
    setCountDownMusicMuted(context, {isMuted}) {
      context.commit('setCountDownMusicMuted', isMuted);
    },
    setMusicPermissionDialogSeen(context, {seen}) {
      context.commit('setMusicPermissionDialogSeen', seen);
    },
    setProjectType(context, {project_type}) {
      context.commit('setProjectType', project_type);
    },
    setMeetingListPreference(context, {value}) {
      context.commit('setMeetingListPreference', value);
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/general.js